import {Card, Typography} from 'antd';
import PropTypes from 'prop-types';

const {Text} = Typography;

const StatCard = ({
  label,
  value,
  icon,
  color = '#7c94ba',
  className = '',
}) => {
  return (
    <Card
      size={'small'}
      styles={{padding: '16px'}}
      className={`rounded-xl border-0 bg-primary-900 shadow-sm ${className}`}
    >
      <div className={'flex  md:flex-row flex-col items-center gap-3'}>
        
        {/* Icon */}
        <div
          className={
            'w-10 h-10 rounded-lg flex items-center justify-center text-white text-lg shrink-0'
          }
          style={{backgroundColor: color}}
        >
          {icon}
        </div>

        {/* Content */}
        <div className={'flex flex-col'}>
          <Text className={'md:text-lg font-medium text-primary-50'}>
            {label}
          </Text>

          <Text
            strong
            className={'text-2xl text-primary-200 leading-none'}
          >
            {value}
          </Text>
        </div>
      </div>
    </Card>
  );
};

StatCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  icon: PropTypes.node,
  color: PropTypes.string,
  bg: PropTypes.string,
  className: PropTypes.string,
};

export default StatCard;
